
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'car': {
    width: 21,
    height: 8.5,
    viewBox: '0 0 21 8.5',
    data: '<path pid="0" d="M21 5.6v-.3c0-1.2-.9-2.1-2.1-2.2-1.2-.1-2.5-.4-3.7-.8 0 0-3.1-2-3.8-2.1-1.7-.3-3.5-.3-5.2.2C5.9.5 2.9 1.8 2.1 2H.9c-.2 0-.2.1-.2.3-.2.3-.2.6-.1 1v.5L.3 4c-.1.2-.7 1.6.1 2.3h.1l1.4.1c.1 1 .9 1.9 1.9 2 1-.1 1.8-.9 1.9-1.9h.1l9.4.2c.2.9.9 1.6 1.8 1.7.8-.1 1.5-.7 1.8-1.5h1c.6.1 1.2-.3 1.2-.9v-.4z"/>'
  }
})
